export const PROJECT_ROUTE = 'projects/:id/:cbTabRouteId/';
